import Tile from "./Tile";

export default Tile;